import React, { useState, useEffect } from 'react';
import { Typography, Box } from '@mui/material';
import logoPlaceHolder from '../assets/logoPlaceholder.jpg';
import { useTheme } from '@mui/system';


const PackageInfoCard = ({ downloadUrl, packageInfo }) => {
  const [imageAvailable, setImageAvailable] = useState(true);
  const [parsedInfo, setParsedInfo] = useState({});
  const [imageUrl, setImageUrl] = useState('');
  const theme = useTheme()


  useEffect(() => {
    // const parsedInfo = JSON.parse(packageInfo?.details?.info ?? '{}');
    const parsedInfo = packageInfo?.details?.info ?? {}
    const imageUrl = `${downloadUrl}/${parsedInfo?.logo}`;
    setParsedInfo(parsedInfo);
    if (imageUrl) {
      setImageUrl(imageUrl);
      setImageAvailable(true)
    }
  }, [packageInfo, downloadUrl])



  return (
    <Box sx={{ padding: '20px' }}>
      <Box sx={{
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
          flexDirection: "column",
          justifyContent: "center"
        }
      }}>
        {imageAvailable ? (
          <Box sx={{
            width: "80px",
            marginRight: "20px",
          }}>
            <img
              src={imageUrl}
              alt="packageIcon"
              style={{ width: '100%' }}
              onError={() => setImageAvailable(false)}
            />
          </Box>
        ) : (
          // <Skeleton variant="rectangular" width={200} height={100} />
          <Box sx={{
            width: "80px",
            marginRight: "20px"
          }}>
            <img
              src={logoPlaceHolder}
              alt="packageIcon"
              style={{ width: '100%' }}
            />
          </Box>
        )}

        <div className="package-details">

          <Typography variant="h5" sx={{ typography: { sm: 'subheading' }, fontWeight: 600 }} >{packageInfo?.details?.templateName} {packageInfo?.details?.isEnabled === 0 ? <Typography sx={{ fontWeight: 'bold' }}> (Disabled)</Typography>   : ''}</Typography>
          <Typography
            variant="body2"
            sx={{
              padding: "5px 10px",
              borderRadius: "25px",
              background: "#EBEBEB",
              display: "inline-block",
              fontWeight: '500',
              margin: "5px 0"
            }}
          >
            {packageInfo?.details?.categoryName || "Others"
            }
          </Typography>
          <Typography sx={{ color: theme => theme.palette.primary.textColor }} variant='body2'>{parsedInfo.summary ? parsedInfo.summary : 'Package summary goes here'}</Typography>
        </div>
      </Box>

    </Box>
  );
};

export default PackageInfoCard;
